import React from 'react'
import { FormGroup as ReactstrapFormGroup, FormGroupProps } from 'reactstrap'

export const FormGroup: React.FC<FormGroupProps> = props => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <ReactstrapFormGroup {...(props as any)} />
}
